import { useMutation } from '@tanstack/react-query'
import { publicApi } from './publicApi'
import { ENDPOINTS } from '@/config/api.config'

export interface CompanyContactDTO {
  name: string
  company: string
  email: string
  phone?: string
  /** Honeypot — humano deixa vazio. Ver `contacts.schema.ts` no back. */
  website?: string
}

/** Envia o formulário comercial da landing /para-empresas. */
export function useSubmitCompanyContact() {
  return useMutation({
    mutationFn: async (dto: CompanyContactDTO) => {
      const { data } = await publicApi.post<{ success: boolean }>(ENDPOINTS.contacts.submit, dto)
      return data
    },
  })
}
